import React, { useEffect, useState } from "react";
import { StyledNotification, StyledX } from "../../dashboard.style";
import NotificationIcon from "./NotificationIcon";
import NotificationInner from "./NotificationInner";
import { ReactComponent as DeleteX } from "../../../../img/DeleteX.svg";

const Notification = ({ type, content, CTA, onDismiss }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    return () => setShow(false);
  }, []);

  if (show) {
    return (
      <StyledNotification type={type}>
        <NotificationIcon type={type} />
        <NotificationInner
          type={type}
          content={content}
          CTA={() => {
            CTA && CTA();
            setShow(false);
          }}
        />
        <StyledX>
          <DeleteX
            onClick={() => {
              onDismiss && onDismiss();
              setShow(false);
            }}
          />
        </StyledX>
      </StyledNotification>
    );
  } else {
    return null;
  }
};
export default Notification;
